export default __webpack_public_path__ + "static/media/hidraulic16.2e639aac.jpg";